import { ProductIdent, ProductVisibility } from "@coaching-culture/types";
import { Box, Button, Grid, Loader } from "@coaching-culture/ui";
import { PageHeader } from "components/PageHeader";
import { useAllProductVisibility } from "hooks/useProductVisibility";
import { LessonModuleWidget } from "pages/Dashboard/Widgets/LessonModuleWidget";
import { useTeam } from "queries/performance";
import { useDeleteRelationship } from "queries/team";
import { FaTrash } from "react-icons/fa";
import { useHistory, useParams } from "react-router";
import { ConversationsWidget } from "./ConversationsWidget";
import { DocumentsWidget } from "./DocumentsWidget";
import { FeedbackWidget } from "./FeedbackWidget";
import { GoalWidgets } from "./GoalWidgets";
import { MeasuresWidget } from "./MeasuresWidget";
import { MeasuresTrendsWidget } from "./MeasureTrendsWidget";

export const RelationshipProfile = () => {
  const { userId } = useParams<{ userId: string }>();
  const team = useTeam();
  const products = useAllProductVisibility();
  const deleteRelationship = useDeleteRelationship();
  const history = useHistory();

  const hasProduct = (ident: ProductIdent) => {
    return products[ident] === ProductVisibility.Enabled;
  };

  const teamUser = team.data?.directReports.find((x) => x.id === userId);

  if (teamUser == null) {
    return <Loader />;
  }

  const onDelete = () => {
    if (window.confirm("Are you sure you want to remove this relationship?")) {
      deleteRelationship
        .mutateAsync(teamUser.relationship.id)
        .then(() => history.push("/solutions/my-team"));
    }
  };

  return (
    <Box p={3} maxWidth={1200}>
      <PageHeader
        text={teamUser.name}
        subtitle={teamUser.jobTitle || teamUser.email}
        backUrl="/solutions/my-team"
      >
        <Button
          icon={FaTrash}
          color="danger"
          onClick={onDelete}
          disabled={deleteRelationship.isLoading}
        >
          Delete relationship
        </Button>
      </PageHeader>
      <Grid gridGap={3} gridTemplateColumns="1fr">
        {hasProduct("performance") && (
          <>
            <DocumentsWidget userId={teamUser.id} />
            <GoalWidgets userId={teamUser.id} />
            <ConversationsWidget withUser={teamUser.id} />
            {hasProduct("measures") && (
              <>
                <MeasuresWidget relationshipId={teamUser.relationship.id} />
                <MeasuresTrendsWidget
                  relationshipId={teamUser.relationship.id}
                />
              </>
            )}
          </>
        )}
        {hasProduct("cont-feedback") && <FeedbackWidget userId={teamUser.id} />}
        {hasProduct("mindset") && (
          <LessonModuleWidget contentType="module" userId={teamUser.id} />
        )}
        {hasProduct("lessons") && (
          <LessonModuleWidget contentType="lesson" userId={teamUser.id} />
        )}
        {hasProduct("learncast") && (
          <LessonModuleWidget contentType="learncast" userId={teamUser.id} />
        )}
      </Grid>
    </Box>
  );
};
